tooltips = {
	init: function() {
		var
			self = this;

		$('[data-tippy-set]').each(function() {
			self.tippy(this);
		});

		self.tippy(document.body);
	},

	//-------------------------------------------------
	//Создать подсказки TippyJs
	tippy: function(container) {
		var
			elements = container.querySelectorAll('[data-tippy-content]:not(.ok)'),
			instances;

		instances = tippy(elements, {
			theme: 'planb',
			animation: 'planb'
		});

		tippy.createSingleton(instances, {
			placement: 'top',
			animation: 'planb',
			overrides: ['theme'],
			moveTransition: 'transform 0.2s ease-out'
		});

		$(elements).addClass('ok');
	}
}



$(document).ready(function() {
	tooltips.init();
});